///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format, parse } from "date-fns";
import { START_DATE, END_DATE } from "@datepicker-react/hooks";

const supportedTokens = ["d", "M", "y"];
export const getLiveTypePattern = (pattern) => {
  let liveTypePattern = pattern.split("");
  for (let i = 0; i < liveTypePattern.length; i++) {
    if (supportedTokens.includes(liveTypePattern[i])) {
      liveTypePattern[i] = "#";
    }
  }
  liveTypePattern = `${liveTypePattern.join("")} - ${liveTypePattern.join("")}`;
  return liveTypePattern;
};

export const isInputDelete = (liveTypePattern, value) => {
  const currentDisplayValue = liveTypePattern.split("#")[0];
  return value.length < currentDisplayValue.length;
};

export const getNewValue = (
  value,
  liveTypePattern,
  setLiveTypePattern,
  format
) => {
  const isDelete = isInputDelete(liveTypePattern, value);
  let newLivePattern = liveTypePattern.split("");
  const nextChar = value[value.length - 1];
  const isMultiDelete = newLivePattern.length - value.length > 1;

  if (isDelete) {
    let originalLiveTypePattern = getLiveTypePattern(format).split("");
    if (!value) {
      setLiveTypePattern(originalLiveTypePattern.join(""));
      return value;
    }
    newLivePattern[value.length] = originalLiveTypePattern[value.length];
    if (isMultiDelete) {
      for (
        let i = originalLiveTypePattern.length - 1;
        i > value.length - 1;
        i--
      ) {
        newLivePattern[i] = originalLiveTypePattern[i];
      }
    }
    for (let i = value.length - 1; i >= 0; i--) {
      if (originalLiveTypePattern[i] === "#") {
        newLivePattern[i] = originalLiveTypePattern[i];
      } else if (
        (originalLiveTypePattern[i] !== " " &&
          originalLiveTypePattern[i] !== "-") ||
        (originalLiveTypePattern[i] === " " &&
          originalLiveTypePattern[i - 1] === "-")
      ) {
        break;
      }
    }
  } else {
    for (let i = 0; i < newLivePattern.length; i++) {
      if (newLivePattern[i] === "#") {
        newLivePattern[i] = nextChar;
        break;
      }
    }
  }
  setLiveTypePattern(newLivePattern.join(""));
  return newLivePattern.join("").split("#")[0];
};

export const getInputValueFromStartDate = (
  startDate,
  datePattern,
  setLiveTypePattern
) => {
  const originalLiveTypePattern = getLiveTypePattern(datePattern);
  const dateString = format(startDate, datePattern);
  const endString = originalLiveTypePattern.slice(
    dateString.length,
    originalLiveTypePattern.length
  );
  const newLiveTypePattern = dateString + endString;
  setLiveTypePattern(newLiveTypePattern);
  return newLiveTypePattern.split("#")[0];
};

export const getInputValueFromEndDate = (
  endDate,
  datePattern,
  liveTypePattern,
  setLiveTypePattern
) => {
  const dateString = format(endDate, datePattern);
  const startString = liveTypePattern.slice(0, dateString.length + 3);
  const newLiveTypePattern = startString + dateString;
  setLiveTypePattern(newLiveTypePattern);
  return newLiveTypePattern.split("#")[0];
};

export const setDatesFromLiveTypePattern = (
  liveTypePattern,
  prevLiveTypePattern,
  dateFormat,
  focusedInput,
  inputValue,
  isDateBlocked,
  handleDateSelect,
  handleOpen,
  setLiveTypePattern,
  setInputValue,
  setFocusedInput
) => {
  const originalLiveTypePattern = getLiveTypePattern(dateFormat);
  const startDateString = liveTypePattern.slice(0, dateFormat.length);
  const endDateString = liveTypePattern.slice(
    dateFormat.length + 3,
    liveTypePattern.length
  );
  const startDateReadyForParse = !startDateString.includes("#");
  const endDateReadyForParse = !endDateString.includes("#");
  let startDate = null;
  let endDate = null;
  if (startDateReadyForParse) {
    startDate = parse(startDateString, dateFormat, new Date());
    if (
      isNaN(startDate.getTime()) ||
      format(startDate, dateFormat) !== startDateString ||
      isDateBlocked(startDate)
    ) {
      startDate = null;
    }
  }
  if (endDateReadyForParse) {
    endDate = parse(endDateString, dateFormat, new Date());
    if (
      isNaN(endDate.getTime()) ||
      format(endDate, dateFormat) !== endDateString ||
      endDate < startDate ||
      isDateBlocked(endDate)
    ) {
      endDate = null;
    }
  }
  if (startDate === null && startDateReadyForParse) {
    setLiveTypePattern(originalLiveTypePattern);
    setInputValue("");
    setFocusedInput(START_DATE);
  } else if (endDate === null && endDateReadyForParse) {
    const newLiveTypePattern =
      liveTypePattern.slice(0, dateFormat.length) +
      originalLiveTypePattern.slice(
        dateFormat.length,
        originalLiveTypePattern.length
      );
    setLiveTypePattern(newLiveTypePattern);
    setInputValue(newLiveTypePattern.split("#")[0]);
    setFocusedInput(END_DATE);
  }
  if (startDate === null && inputValue) {
    setFocusedInput(START_DATE);
    handleDateSelect(null, null);
  }
  if (startDate !== null && endDate === null && focusedInput === START_DATE) {
    setFocusedInput(END_DATE);
    handleDateSelect(startDate, null);
  } else if (
    endDate !== null &&
    startDate !== null &&
    focusedInput === END_DATE
  ) {
    handleDateSelect(startDate, endDate);
    setFocusedInput(START_DATE);
    handleOpen(false);
  } else if (!inputValue && prevLiveTypePattern) {
    handleDateSelect(null, null);
    setFocusedInput(START_DATE);
  }
};
